import React from 'react';
import { CheckCircle2, Clock } from 'lucide-react';
import { mockData } from '../mock/mockData';

const Roadmap = () => {
  const { roadmap } = mockData;

  return (
    <section id="roadmap" className="roadmap-section">
      <div className="section-container">
        <h2 className="section-title">{roadmap.title}</h2>
        
        <div className="roadmap-grid">
          {roadmap.phases.map((phase, index) => (
            <div 
              key={index} 
              className={`roadmap-card ${phase.status === 'active' ? 'roadmap-active' : ''}`}
            >
              <div className="roadmap-header">
                <span className="roadmap-phase">{phase.phase}</span>
                {phase.status === 'active' ? (
                  <CheckCircle2 size={24} className="roadmap-icon-active" />
                ) : (
                  <Clock size={24} className="roadmap-icon-upcoming" />
                )}
              </div>
              <h3 className="roadmap-title">{phase.title}</h3>
              <ul className="roadmap-list">
                {phase.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="roadmap-item">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
